<template>
  <div v-if="round">
    <div v-if="!currentView" class="row q-pa-md items-center">
      <div style="display: inline-block" class="text-h6">
        {{
          round.round_name == "Final 1"
            ? "Final"
            : round.round_name == "Heats 1"
            ? "Heats"
            : round.round_name
        }}
      </div>
      <div
        class="col-12"
        v-if="currentRound.races && currentRound.races.length > 0"
      >
        <q-scroll-area style="height: calc(100vh - 280px)">
          <div
            class="row"
            v-for="(race, index) in currentRound.races"
            :key="`race_${index}`"
          >
            <div class="col-12 race" v-if="currentRound.races.length > 1">
              <div v-if="race.label" class="text-h6 raceTitle">
                {{ race.label }}
              </div>
              <div v-else-if="round.is_final != 1" class="text-h6 raceTitle">
                Heat {{ race.race_index + 1 }}
              </div>
              <div v-else class="text-h6 raceTitle">
                Heat {{ race.race_index + 1 }}
              </div>
            </div>
            <div class="col-12">
              <q-card flat bordered>
                <q-card-section>
                  <div class="row text-center">
                    <div class="col-12 q-mb-sm col-sm-4">
                      <q-btn
                        :color="race.marshalled ? 'positive' : 'primary'"
                        v-if="race.race_index == 0"
                        :label="`Marshall`"
                        @click="setView(index, 'marshall')"
                        no-caps
                        class="full-width"
                      >
                        <q-icon
                          v-if="race.marshalled"
                          class="q-ml-md"
                          size="sm"
                          name="mdi-check"
                        ></q-icon>
                      </q-btn>
                    </div>
                    <div class="col-6 q-mb-sm col-sm-4">
                      <q-btn
                        :color="race.checkedIn ? 'positive' : 'primary'"
                        :label="`Checkin`"
                        @click="setView(index, 'checkin')"
                        no-caps
                        :disable="!currentRound.races[0].marshalled"
                        style="width: 150px"
                      >
                        <q-icon
                          v-if="race.checkedIn"
                          class="q-ml-md"
                          size="sm"
                          name="mdi-check"
                        ></q-icon>
                      </q-btn>
                    </div>
                    <div class="col-6 col-sm-4">
                      <q-btn
                        :color="race.resultsPublished ? 'positive' : 'primary'"
                        label="Results"
                        @click="setView(index, 'results')"
                        no-caps
                        :disable="!race.checkedIn"
                        style="width: 150px"
                      >
                        <q-icon
                          v-if="race.resultsPublished"
                          class="q-ml-md"
                          size="sm"
                          name="mdi-check"
                        ></q-icon>
                      </q-btn>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-scroll-area>
      </div>
      <div v-else class="col-12">No Races</div>
    </div>
    <div v-if="currentView">
      <q-card-section class="q-pa-none">
        <div class="row">
          <div
            class="col-12 mt-0 pt-0"
            style="height: calc(100vh - 405px) !important"
          >
            <component
              ref="currentView"
              v-bind:is="views[currentView]"
              :raceIndex="currentRace"
              :round="currentRound"
              @close="
                currentRace = 0;
                currentView = null;
                $emit('changeCurrentView', null);
              "
            ></component>
          </div>
        </div>
      </q-card-section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import marshall from "@/components/wavesProgress/marshall.vue";
import results from "@/components/wavesProgress/results.vue";
import checkin from "@/components/wavesProgress/checkin.vue";
// import { Notify } from "quasar";

export default {
  components: {},
  props: {
    round: {
      default: null
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      registeredParticipants: "events/registeredParticipants",
      event: "events/current",
      currentRound: "eventProgress/currentRound",
      currentRoundLoading: "eventProgress/currentRoundLoading"
    })
  },
  data: () => ({
    currentRace: 0,
    currentView: null,
    views: {
      marshall: marshall,
      checkin: checkin,
      results: results
    }
  }),
  watch: {
    round: function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.round.id) {
        this.$store.dispatch("eventProgress/loadCurrentRound", this.round.id);
        this.$store.dispatch(
          "competitions/updateOmega",
          this.$route.params.competitions_id
        );
      }
    },
    setView(index, view) {
      this.currentRace = index;
      this.currentView = view;
      this.$emit("changeCurrentView", view);
    }
  }
};
</script>

<style scoped lang="scss">
.race {
  .raceTitle {
    display: inline-block;
    font-size: 12pt;
  }
}
</style>
